<template>
  <div class="protected-page">
    <div v-if="data">
      <h2 class="title is-4 pb-3 py-2">Espace professionnel</h2>
      <span v-html="data.contenu"></span>
      <button @click="logout" class="logout-btn">Déconnexion</button>
    </div>

    <div v-else>
      <h2>Accès protégé</h2>
      <input
        v-model="password"
        type="password"
        placeholder="Mot de passe"
        @keyup.enter="submitPassword"
      />
      <button @click="submitPassword">Valider</button>
      <p v-if="error" class="error">{{ error }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      password: '',
      data: null,
      error: ''
    };
  },
  methods: {
    async submitPassword() {
      this.error = '';
      try {
        const response = await fetch('/espacepro/get_data.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'text/plain'
          },
          body: this.password
        });

        const result = await response.json();

        if (!response.ok) {
          this.error = result.error || 'Erreur inconnue';
        } else {
          this.data = result;
        }
      } catch (e) {
        this.error = 'Erreur lors de la requête';
        console.error(e);
      }
    },
    async logout() {
      try {
        await fetch('/espacepro/logout.php', { method: 'POST' });
        this.data = null;
        this.password = '';
        this.error = '';
      } catch (e) {
        console.error('Erreur de déconnexion', e);
      }
    }
  },
  async mounted() {
    // Vérifie si déjà authentifié via session (appel sans mot de passe)
    try {
      const response = await fetch('/espacepro/get_data.php?check=1', {
        method: 'POST'
      });

      const result = await response.json();

      // Si déjà authentifié, le backend renvoie directement les données protégées
      // Backend renvoie {authenticated:false} quand non loggé
      if (response.ok && !(result && result.authenticated === false)) {
        this.data = result;
      }
    } catch (e) {
      console.warn('Pas encore authentifié');
    }
  }
};
</script>

<style scoped>
.protected-page {
  max-width: 500px;
  margin: auto;
  padding: 20px;
}
input {
  width: 100%;
  padding: 8px;
  margin-top: 10px;
}
button {
  margin-top: 10px;
  padding: 8px 12px;
}
.logout-btn {
  margin-top: 20px;
  background-color: #c00;
  color: white;
  border: none;
}
.error {
  color: red;
  margin-top: 10px;
}
</style>
